import { render } from "./DishModal.vue?vue&type=template&id=464f0176&lang=pug"
import script from "./DishModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DishModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__